import { ChakraProvider } from "@chakra-ui/react";
import { Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import BobPage from "./pages/bob/BobPage";
import ScrollToTop from "./components/ScrollToTop";
import theme from "./theme"

function App() {
  return (
    <ChakraProvider theme={theme}>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/bob" element={<BobPage />} />
      </Routes>
    </ChakraProvider>
  );
}

export default App;
